import React from "react";
import { Check } from "lucide-react";
import HologramHero from "../components/HologramHero";
import AiBadge from "../components/AiBadge";
import Icon from "../components/Icon";
import { IMAGES } from "../data/content";
import { useI18n } from "../i18n/LanguageContext";

const withBreaks = (lines = []) =>
  lines.map((l, i) => (
    <React.Fragment key={i}>
      {l}
      {i < lines.length - 1 && <br />}
    </React.Fragment>
  ));

export default function Leistungen() {
  const { t } = useI18n();
  const l = t.leistungen;

  return (
    <div data-testid="page-leistungen">
      <HologramHero
        label={l.hero.label}
        image={IMAGES.heroLeistungen}
        title={withBreaks(l.hero.titleLines)}
        paragraphs={l.hero.paragraphs}
        badges={l.hero.badges}
        cards={l.hero.cards}
      />

      {/* Service cards */}
      <section className="py-20 bg-white" data-testid="leistungen-cards">
        <div className="max-w-[1320px] mx-auto px-5 lg:px-8">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-7">
            {l.services.map((s) => (
              <div
                key={s.key}
                data-testid={`service-card-${s.key}`}
                className="card-hover relative bg-white border border-line rounded-2xl overflow-hidden flex flex-col"
              >
                <div className="h-44 bg-cover bg-center" style={{ backgroundImage: `url(${s.image})` }} />
                <AiBadge className="absolute bottom-2 right-2 z-10" />
                <div className="p-6 flex flex-col flex-1">
                  <div className="flex items-center gap-3 mb-3">
                    <Icon name={s.icon} size={26} className="text-blue-brand" strokeWidth={1.7} />
                    <h3 className="font-head font-bold text-ink uppercase tracking-wide text-[15px]">{s.title}</h3>
                  </div>
                  <p className="text-sm text-muted-foreground leading-relaxed mb-5">{s.long}</p>
                  <ul className="space-y-2.5 mt-auto">
                    {s.points.map((p) => (
                      <li key={p} className="flex items-center gap-3 text-sm text-ink">
                        <span className="w-5 h-5 rounded-full bg-blue-50 flex items-center justify-center shrink-0">
                          <Check size={13} className="text-blue-brand" strokeWidth={3} />
                        </span>
                        {p}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Unser Ansatz */}
      <section className="py-16 section-soft" data-testid="leistungen-ansatz">
        <div className="max-w-[1320px] mx-auto px-5 lg:px-8">
          <h2 className="text-blue-brand font-head font-bold uppercase tracking-[0.18em] text-sm mb-10">{l.ansatzTitle}</h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-x-6 gap-y-10">
            {l.ansatz.map((a) => (
              <div key={a.title} className="border-l-2 border-blue-100 pl-5">
                <Icon name={a.icon} size={32} className="text-blue-brand mb-4" strokeWidth={1.5} />
                <h3 className="font-head font-bold text-ink text-[14px] uppercase tracking-wide mb-2">{a.title}</h3>
                <p className="text-sm text-muted-foreground leading-relaxed">{a.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
